export default "__VITE_ASSET__wR7m5Z3H__"